export const resources = {
  HeaderHelpLinkAria: '',
  SidebarAccounts: '',
  SidebarUserSettings: '',
  SideBarCloseLabel: '',
  SidebarUserNotifications: ''
};
